import { CanAccess } from '@modules/common/components/CanAccess';
import { CircularLoader } from '@modules/common/components/CircularLoader';
import { Stack, Switch, Typography } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { ChangeEvent } from 'react';
import { Scope } from 'v2/core/entities/scope';

interface AnalysisScopeSwitchProps {
  scope: Scope;
  onChange: (checked: boolean) => void;
  isLoading?: boolean;
  type?: 'analysis' | 'dashboard' | 'compare' | 'search';
}

export const AnalysisScopeSwitch = ({
  scope,
  onChange,
  isLoading = false,
  type = 'analysis',
}: AnalysisScopeSwitchProps) => {
  const isPublic = scope === Scope.PUBLIC;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Stack pr={2} spacing={1}>
        <Typography variant="button">{type} discovery</Typography>
        <Typography mt={1} variant="subtitle1">
          Discoverable {type} is visible to anyone within the organisation.
          Otherwise, {type} can only be accessed by its shareable link.
        </Typography>
      </Stack>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        minWidth="100px"
      >
        {!isLoading ? (
          <>
            <CanAccess
              resource={PermissionResource.Artefact}
              operation={PermissionOperation.Write}
            >
              <Switch
                checked={isPublic}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  onChange(e.target.checked)
                }
              />
            </CanAccess>
            <Typography mt={1} variant="overline">
              {isPublic ? 'DISCOVERABLE' : 'UNDISCOVERABLE'}
            </Typography>
          </>
        ) : (
          <CircularLoader size={24} />
        )}
      </Stack>
    </Stack>
  );
};
